





















































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { hiddenDangerLibraryServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import html2canvas from 'html2canvas';

@Component({
  components: {},
})
export default class DetailView extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  exportTable() {
    console.log(456);
    const clientWidth = (document.getElementById('treeNodeBox') as any).offsetWidth;
    const clientHeight = (document.getElementById('treeNodeBox') as any).offsetHeight;
    const kh = [clientWidth, clientHeight];

    html2canvas(document.getElementById('treeNodeBox') as any, { useCORS: true, logging: true }).then(canvas => {
      const dataURL = canvas.toDataURL('image/png', 1.0);
      this.download(dataURL, kh);
    });
  }
  download(imgUrl: any, kh: any) {
    this.getUrlBase64(imgUrl, kh).then(base64 => {
      const link: any = document.createElement('a');
      link.href = base64;
      link.download = `${this.formData.areaName} + ${this.formData.orderCode}.jpg`;
      link.click();
    });
  }
  getUrlBase64(url: any, kh: any) {
    return new Promise(resolve => {
      let canvas: any = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = '*'; // 允许跨域
      img.src = url;
      img.onload = () => {
        // eslint-disable-next-line prefer-destructuring
        canvas.height = kh[1];
        // eslint-disable-next-line prefer-destructuring
        canvas.width = kh[0];
        ctx.drawImage(img, 0, 0, kh[0], kh[1]);
        const dataURL = canvas.toDataURL('image/png');
        canvas = null;
        resolve(dataURL);
      };
    });
  }

  // 表单数据
  formData: any = {};

  formRules: any = {};
  imgPath: any = publishObjectPath.imgPathWater;
  dataType: any = [
    {
      name: '基本信息',
    },
    {
      name: '整改信息',
    },
    {
      name: '操作日志',
    },
  ];
  tabValue: any = '基本信息';

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取隐患详情数据
    this.getDetailByIdData();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    hiddenDangerLibraryServer
      .getHazardManageDetail(this.row.id)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  getLevel(data: any) {
    if (data === 'A') {
      return '重大隐患(A)';
    }
    if (data === 'B') {
      return '一般隐患I级(B)';
    }
    if (data === 'C') {
      return '一般隐患II级(C)';
    }
    if (data === 'D') {
      return '一般隐患III级(D)';
    }
  }

  tabChange(value: any) {
    this.tabValue = value.name;
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.imgPath}${item.path}`);
    });
    return arr;
  }
}
